import React, { Component } from 'react';

class StickyBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      dismissed: false,
    };

    this.$stickyBlockRef = React.createRef();
  }

  handleScroll = () => {
    const sticky = this.$stickyBlockRef.current;
    if (!sticky || this.state.dismissed) return;

    const stickyEnter = parseInt(sticky.getAttribute('data-sticky-start'), 10);

    if (window.scrollY >= stickyEnter) {
      sticky.classList.add('sticky');
      sticky.classList.remove('not-stuck');
    } else {
      sticky.classList.remove('sticky');
      sticky.classList.add('not-stuck');
    }
  };

  setHeaderHeightAttr = () => {
    const sticky = this.$stickyBlockRef.current;
    if (!sticky) return;
    const headerHeight = sticky.parentNode?.parentNode?.children[0]?.scrollHeight || 0;
    sticky.setAttribute('data-sticky-start', headerHeight);
  };

  handleDismiss = () => {
    this.setState({ dismissed: true });
    if (this.props.onDismiss) {
      this.props.onDismiss();
    }
  };

  componentDidMount() {
    this.setHeaderHeightAttr();
    this.handleScroll();

    window.addEventListener('scroll', this.handleScroll, false);
    window.addEventListener('resize', this.handleScroll, false);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll, false);
    window.removeEventListener('resize', this.handleScroll, false);
  }

  componentDidCatch() {
    this.setState({ error: true });
  }

  render() {
    const { children, dismissable = false } = this.props;
    const { error, dismissed } = this.state;

    if (dismissed) return null;

    return error ? (
      children
    ) : (
      <div
        className={`sticky-block ${dismissable ? 'sticky-block-dismissable' : ''}`}
        ref={this.$stickyBlockRef}
      >
        {children}
      </div>
    );
  }
}

export default StickyBlock;
